const svgToDataUri = (svg) =>
    `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(
        svg.replace(/\s{2,}/g, ' ').trim()
    )}`;

export const LOCKED_INVESTOR_INVESTMENTS_IMAGE = svgToDataUri(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1360 332" fill="none">
    <defs>
        <filter id="locked-investments-blur" x="-20%" y="-20%" width="140%" height="140%">
            <feGaussianBlur stdDeviation="6" />
        </filter>
    </defs>
    <rect width="1360" height="332" rx="14" fill="#FFFFFF"/>
    <rect x="1" y="1" width="1358" height="330" rx="13" stroke="#EAECF0"/>
    <rect width="1360" height="56" rx="14" fill="#FFFFFF"/>
    <line x1="0" y1="56.5" x2="1360" y2="56.5" stroke="#EAECF0"/>

    <g fill="#667085" font-family="Arial, sans-serif" font-size="11" font-weight="700">
        <text x="24" y="35">Company</text>
        <text x="226" y="35">HQ</text>
        <text x="346" y="35">Stage</text>
        <text x="454" y="35">Date</text>
        <text x="580" y="35">Investment</text>
        <text x="742" y="35">Round Size</text>
        <text x="914" y="35">Valuation</text>
        <text x="1086" y="35">Investors</text>
        <text x="1230" y="35">Follow-on</text>
    </g>

    <g filter="url(#locked-investments-blur)">
        <rect x="24" y="82" width="132" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="226" y="82" width="72" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="346" y="82" width="78" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="454" y="82" width="62" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="580" y="82" width="84" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="742" y="82" width="88" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="914" y="82" width="108" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="1086" y="82" width="44" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="1230" y="82" width="58" height="12" rx="6" fill="#D0D5DD"/>

        <rect x="24" y="150" width="132" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="226" y="150" width="88" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="346" y="150" width="76" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="454" y="150" width="64" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="580" y="150" width="90" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="742" y="150" width="92" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="914" y="150" width="112" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="1086" y="150" width="48" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="1230" y="150" width="72" height="12" rx="6" fill="#D0D5DD"/>

        <rect x="24" y="218" width="132" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="226" y="218" width="70" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="346" y="218" width="88" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="454" y="218" width="60" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="580" y="218" width="96" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="742" y="218" width="80" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="914" y="218" width="104" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="1086" y="218" width="40" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="1230" y="218" width="56" height="12" rx="6" fill="#D0D5DD"/>

        <rect x="24" y="286" width="132" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="226" y="286" width="76" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="346" y="286" width="82" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="454" y="286" width="66" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="580" y="286" width="88" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="742" y="286" width="94" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="914" y="286" width="110" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="1086" y="286" width="46" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="1230" y="286" width="64" height="12" rx="6" fill="#D0D5DD"/>
    </g>

    <line x1="0" y1="124.5" x2="1360" y2="124.5" stroke="#F2F4F7"/>
    <line x1="0" y1="192.5" x2="1360" y2="192.5" stroke="#F2F4F7"/>
    <line x1="0" y1="260.5" x2="1360" y2="260.5" stroke="#F2F4F7"/>
</svg>
`);

export const LOCKED_FUNDS_INVESTED_IMAGE = svgToDataUri(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1240 332" fill="none">
    <defs>
        <filter id="locked-funds-invested-blur" x="-20%" y="-20%" width="140%" height="140%">
            <feGaussianBlur stdDeviation="6" />
        </filter>
    </defs>
    <rect width="1240" height="332" rx="14" fill="#FFFFFF"/>
    <rect x="1" y="1" width="1238" height="330" rx="13" stroke="#EAECF0"/>
    <rect width="1240" height="56" rx="14" fill="#FFFFFF"/>
    <line x1="0" y1="56.5" x2="1240" y2="56.5" stroke="#EAECF0"/>

    <g fill="#667085" font-family="Arial, sans-serif" font-size="10" font-weight="700">
        <text x="24" y="35">Fund Manager</text>
        <text x="246" y="35">Investor(s)</text>
        <text x="474" y="35">Amount</text>
        <text x="622" y="35">Date</text>
        <text x="754" y="35">Vehicle</text>
        <text x="1016" y="35">Verified?</text>
    </g>

    <g filter="url(#locked-funds-invested-blur)">
        <rect x="24" y="82" width="156" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="24" y="102" width="96" height="10" rx="5" fill="#E4E7EC"/>
        <rect x="246" y="82" width="146" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="246" y="102" width="84" height="10" rx="5" fill="#E4E7EC"/>
        <rect x="474" y="92" width="72" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="622" y="92" width="58" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="754" y="92" width="162" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="1016" y="92" width="52" height="12" rx="6" fill="#D0D5DD"/>

        <rect x="24" y="150" width="148" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="24" y="170" width="88" height="10" rx="5" fill="#E4E7EC"/>
        <rect x="246" y="150" width="134" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="246" y="170" width="92" height="10" rx="5" fill="#E4E7EC"/>
        <rect x="474" y="160" width="68" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="622" y="160" width="64" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="754" y="160" width="150" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="1016" y="160" width="46" height="12" rx="6" fill="#D0D5DD"/>

        <rect x="24" y="218" width="160" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="24" y="238" width="102" height="10" rx="5" fill="#E4E7EC"/>
        <rect x="246" y="218" width="144" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="246" y="238" width="76" height="10" rx="5" fill="#E4E7EC"/>
        <rect x="474" y="228" width="70" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="622" y="228" width="60" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="754" y="228" width="168" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="1016" y="228" width="50" height="12" rx="6" fill="#D0D5DD"/>

        <rect x="24" y="286" width="152" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="24" y="306" width="94" height="10" rx="5" fill="#E4E7EC"/>
        <rect x="246" y="286" width="138" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="246" y="306" width="90" height="10" rx="5" fill="#E4E7EC"/>
        <rect x="474" y="296" width="74" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="622" y="296" width="62" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="754" y="296" width="156" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="1016" y="296" width="48" height="12" rx="6" fill="#D0D5DD"/>
    </g>

    <line x1="0" y1="124.5" x2="1240" y2="124.5" stroke="#F2F4F7"/>
    <line x1="0" y1="192.5" x2="1240" y2="192.5" stroke="#F2F4F7"/>
    <line x1="0" y1="260.5" x2="1240" y2="260.5" stroke="#F2F4F7"/>
</svg>
`);

export const LOCKED_PORTFOLIO_EXITS_IMAGE = svgToDataUri(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1680 360" fill="none">
    <defs>
        <filter id="locked-exits-blur" x="-20%" y="-20%" width="140%" height="140%">
            <feGaussianBlur stdDeviation="6" />
        </filter>
    </defs>
    <rect width="1680" height="360" rx="14" fill="#FFFFFF"/>
    <rect x="1" y="1" width="1678" height="358" rx="13" stroke="#EAECF0"/>
    <rect width="1680" height="56" rx="14" fill="#FFFFFF"/>
    <line x1="0" y1="56.5" x2="1680" y2="56.5" stroke="#EAECF0"/>

    <g fill="#667085" font-family="Arial, sans-serif" font-size="11" font-weight="700">
        <text x="24" y="35">Name &amp; HQ</text>
        <text x="238" y="35">Primary Industry</text>
        <text x="392" y="35">Exit Type</text>
        <text x="500" y="35">Exit Date</text>
        <text x="602" y="35">Years to Exit</text>
        <text x="722" y="35">Exit Value</text>
        <text x="834" y="35">Total Funding</text>
        <text x="1038" y="35">Deal Count</text>
        <text x="1138" y="35">Acquirer</text>
        <text x="1314" y="35">Acquirer Type</text>
        <text x="1460" y="35">Acquirer Country</text>
    </g>

    <g filter="url(#locked-exits-blur)">
        <rect x="24" y="82" width="148" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="24" y="102" width="112" height="10" rx="5" fill="#E4E7EC"/>
        <rect x="238" y="92" width="120" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="392" y="92" width="72" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="500" y="92" width="68" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="614" y="92" width="44" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="722" y="92" width="72" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="846" y="92" width="96" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="1050" y="92" width="38" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="1138" y="82" width="128" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="1138" y="102" width="92" height="10" rx="5" fill="#E4E7EC"/>
        <rect x="1314" y="92" width="96" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="1460" y="92" width="116" height="12" rx="6" fill="#D0D5DD"/>

        <rect x="24" y="154" width="160" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="24" y="174" width="96" height="10" rx="5" fill="#E4E7EC"/>
        <rect x="238" y="164" width="132" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="392" y="164" width="80" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="500" y="164" width="72" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="614" y="164" width="36" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="722" y="164" width="80" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="846" y="164" width="108" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="1050" y="164" width="42" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="1138" y="154" width="140" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="1138" y="174" width="88" height="10" rx="5" fill="#E4E7EC"/>
        <rect x="1314" y="164" width="90" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="1460" y="164" width="124" height="12" rx="6" fill="#D0D5DD"/>

        <rect x="24" y="226" width="142" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="24" y="246" width="104" height="10" rx="5" fill="#E4E7EC"/>
        <rect x="238" y="236" width="128" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="392" y="236" width="76" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="500" y="236" width="74" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="614" y="236" width="40" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="722" y="236" width="76" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="846" y="236" width="102" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="1050" y="236" width="40" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="1138" y="226" width="136" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="1138" y="246" width="94" height="10" rx="5" fill="#E4E7EC"/>
        <rect x="1314" y="236" width="98" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="1460" y="236" width="118" height="12" rx="6" fill="#D0D5DD"/>

        <rect x="24" y="298" width="154" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="24" y="318" width="88" height="10" rx="5" fill="#E4E7EC"/>
        <rect x="238" y="308" width="116" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="392" y="308" width="84" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="500" y="308" width="68" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="614" y="308" width="42" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="722" y="308" width="82" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="846" y="308" width="98" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="1050" y="308" width="38" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="1138" y="298" width="132" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="1138" y="318" width="90" height="10" rx="5" fill="#E4E7EC"/>
        <rect x="1314" y="308" width="94" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="1460" y="308" width="120" height="12" rx="6" fill="#D0D5DD"/>
    </g>

    <line x1="0" y1="128.5" x2="1680" y2="128.5" stroke="#F2F4F7"/>
    <line x1="0" y1="200.5" x2="1680" y2="200.5" stroke="#F2F4F7"/>
    <line x1="0" y1="272.5" x2="1680" y2="272.5" stroke="#F2F4F7"/>
    <line x1="0" y1="344.5" x2="1680" y2="344.5" stroke="#F2F4F7"/>
</svg>
`);

export const LOCKED_FUNDING_ROUNDS_IMAGE = svgToDataUri(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1320 332" fill="none">
    <defs>
        <filter id="locked-funding-rounds-blur" x="-20%" y="-20%" width="140%" height="140%">
            <feGaussianBlur stdDeviation="6" />
        </filter>
    </defs>
    <rect width="1320" height="332" rx="14" fill="#FFFFFF"/>
    <rect x="1" y="1" width="1318" height="330" rx="13" stroke="#EAECF0"/>
    <rect width="1320" height="56" rx="14" fill="#FFFFFF"/>
    <line x1="0" y1="56.5" x2="1320" y2="56.5" stroke="#EAECF0"/>

    <g fill="#667085" font-family="Arial, sans-serif" font-size="11" font-weight="700">
        <text x="24" y="35">Date</text>
        <text x="176" y="35">Startup</text>
        <text x="390" y="35">Amount</text>
        <text x="556" y="35">Valuation</text>
        <text x="720" y="35">Round</text>
        <text x="874" y="35">Investors</text>
        <text x="1194" y="35">Verified?</text>
    </g>

    <g filter="url(#locked-funding-rounds-blur)">
        <rect x="24" y="92" width="76" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="176" y="82" width="132" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="176" y="102" width="88" height="10" rx="5" fill="#E4E7EC"/>
        <rect x="390" y="92" width="86" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="556" y="92" width="92" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="720" y="92" width="70" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="874" y="82" width="146" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="874" y="102" width="96" height="10" rx="5" fill="#E4E7EC"/>
        <rect x="1194" y="92" width="52" height="12" rx="6" fill="#D0D5DD"/>

        <rect x="24" y="160" width="72" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="176" y="150" width="144" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="176" y="170" width="82" height="10" rx="5" fill="#E4E7EC"/>
        <rect x="390" y="160" width="94" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="556" y="160" width="86" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="720" y="160" width="78" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="874" y="150" width="154" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="874" y="170" width="104" height="10" rx="5" fill="#E4E7EC"/>
        <rect x="1194" y="160" width="48" height="12" rx="6" fill="#D0D5DD"/>

        <rect x="24" y="228" width="80" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="176" y="218" width="138" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="176" y="238" width="90" height="10" rx="5" fill="#E4E7EC"/>
        <rect x="390" y="228" width="88" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="556" y="228" width="90" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="720" y="228" width="74" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="874" y="218" width="148" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="874" y="238" width="92" height="10" rx="5" fill="#E4E7EC"/>
        <rect x="1194" y="228" width="50" height="12" rx="6" fill="#D0D5DD"/>

        <rect x="24" y="296" width="74" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="176" y="286" width="136" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="176" y="306" width="84" height="10" rx="5" fill="#E4E7EC"/>
        <rect x="390" y="296" width="92" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="556" y="296" width="88" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="720" y="296" width="82" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="874" y="286" width="156" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="874" y="306" width="98" height="10" rx="5" fill="#E4E7EC"/>
        <rect x="1194" y="296" width="46" height="12" rx="6" fill="#D0D5DD"/>
    </g>

    <line x1="0" y1="124.5" x2="1320" y2="124.5" stroke="#F2F4F7"/>
    <line x1="0" y1="192.5" x2="1320" y2="192.5" stroke="#F2F4F7"/>
    <line x1="0" y1="260.5" x2="1320" y2="260.5" stroke="#F2F4F7"/>
</svg>
`);

export const LOCKED_TEAM_MEMBERS_IMAGE = svgToDataUri(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1120 264" fill="none">
    <defs>
        <filter id="locked-team-members-blur" x="-20%" y="-20%" width="140%" height="140%">
            <feGaussianBlur stdDeviation="6" />
        </filter>
    </defs>
    <rect width="1120" height="264" rx="14" fill="#FFFFFF"/>
    <rect x="1" y="1" width="1118" height="262" rx="13" stroke="#EAECF0"/>
    <rect width="1120" height="56" rx="14" fill="#FFFFFF"/>
    <line x1="0" y1="56.5" x2="1120" y2="56.5" stroke="#EAECF0"/>

    <g fill="#667085" font-family="Arial, sans-serif" font-size="10" font-weight="700">
        <text x="24" y="35">Name</text>
        <text x="474" y="35">Role</text>
        <text x="842" y="35">Contact</text>
    </g>

    <g filter="url(#locked-team-members-blur)">
        <circle cx="42" cy="92" r="18" fill="#E4E7EC"/>
        <rect x="74" y="84" width="152" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="74" y="104" width="104" height="10" rx="5" fill="#E4E7EC"/>
        <rect x="474" y="92" width="146" height="12" rx="6" fill="#D0D5DD"/>
        <circle cx="854" cy="92" r="12" fill="#D0D5DD"/>
        <circle cx="890" cy="92" r="12" fill="#D0D5DD"/>
        <circle cx="926" cy="92" r="12" fill="#D0D5DD"/>

        <circle cx="42" cy="146" r="18" fill="#E4E7EC"/>
        <rect x="74" y="138" width="166" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="74" y="158" width="92" height="10" rx="5" fill="#E4E7EC"/>
        <rect x="474" y="146" width="132" height="12" rx="6" fill="#D0D5DD"/>
        <circle cx="854" cy="146" r="12" fill="#D0D5DD"/>
        <circle cx="890" cy="146" r="12" fill="#D0D5DD"/>
        <circle cx="926" cy="146" r="12" fill="#D0D5DD"/>

        <circle cx="42" cy="200" r="18" fill="#E4E7EC"/>
        <rect x="74" y="192" width="148" height="12" rx="6" fill="#D0D5DD"/>
        <rect x="74" y="212" width="116" height="10" rx="5" fill="#E4E7EC"/>
        <rect x="474" y="200" width="154" height="12" rx="6" fill="#D0D5DD"/>
        <circle cx="854" cy="200" r="12" fill="#D0D5DD"/>
        <circle cx="890" cy="200" r="12" fill="#D0D5DD"/>
        <circle cx="926" cy="200" r="12" fill="#D0D5DD"/>
    </g>

    <line x1="0" y1="128.5" x2="1120" y2="128.5" stroke="#F2F4F7"/>
    <line x1="0" y1="182.5" x2="1120" y2="182.5" stroke="#F2F4F7"/>
    <line x1="0" y1="236.5" x2="1120" y2="236.5" stroke="#F2F4F7"/>
</svg>
`);
